// docs: https://github.com/altostra/type-validations#readme
import { anyOf, objectOf, primitives } from "@altostra/type-validations";

export const isDiscardCanvasVersionResult = objectOf({
  success: primitives.boolean,
});

export const isCanvasVersionResult = objectOf({
  version_id: primitives.string,
  name: primitives.string,
  created_at: primitives.string,
  developer_name: primitives.string,
  developer_id: anyOf(primitives.string, primitives.nullValidation),
});
